<button
  (click)="setInitialViewDate(); op.toggle($event)"
  [ngClass]="{
    'is-visible-datepicker': op.overlayVisible && false,
    'is-active': _value
  }"
  class="datepicker"
>
  <span class="label">
    {{ label }}
    <ng-container *ngIf="selectionMode === 'single' && _value">
      | {{ _value | date : "mediumDate" : "" : langauge }}
    </ng-container>
    <ng-container *ngIf="selectionMode === 'range' && _value?.length">
      | {{ _value[0] | date : "mediumDate" : "" : langauge }}
      <ng-container *ngIf="_value[1]">
        - {{ _value[1] | date : "mediumDate" : "" : langauge }}
      </ng-container>
    </ng-container>
  </span>
  <button class="toggle-btn">
    <i class="pi pi-chevron-down icon"></i>
  </button>
</button>

<p-popover #op>
  <div class="datepicker-popover">
    <div class="datepicker-popover__actions">
      <div *ngIf="numberOfMonths === 2" class="quick-ranges">
        <button
          *ngFor="let item of timeRangeTips"
          class="quick-ranges__btn"
          [ngClass]="{ 'is-active': isPresetActive(item.value) }"
          (click)="applyPreset(item.value, op)"
        >
          <span>{{ item.label | translate }}</span>
        </button>
      </div>

      <button
        *ngIf="isVisibleTimePicker"
        [ngClass]="{ active: showTimePicker || showSelectDateWarning }"
        pButton
        class="add-time"
        (click)="toggleTimePicker()"
      >
        <i class="pi pi-clock" pButtonIcon></i>
      </button>
    </div>

    <p-datepicker
      [(ngModel)]="_value"
      (ngModelChange)="onDateChange($event, op)"
      [maxDate]="maxDate"
      [inline]="true"
      [selectionMode]="selectionMode"
      [firstDayOfWeek]="1"
      [numberOfMonths]="numberOfMonths"
      [defaultDate]="initialViewDate"
      class="max-w-full"
      severity="primary"
    ></p-datepicker>

    <ng-container *ngIf="showSelectDateWarning && !this.showTimePicker">
      <span class="time-picker__error">
        {{'selectDateToSetHours'|translate}}
      </span>
    </ng-container>

    <div *ngIf="showTimePicker" class="time-picker">
      <div class="time-picker__form">
        <span class="time-picker__date">
          {{ _value[0] | date : "dd MMM" : "" : langauge }}
        </span>
        <p-datepicker
          [(ngModel)]="timePickerFrom"
          [inline]="true"
          [iconDisplay]="'input'"
          [showIcon]="true"
          [timeOnly]="true"
          inputId="timePickerFrom"
        >
          <ng-template #inputicon let-clickCallBack="clickCallBack">
            <i class="pi pi-clock" (click)="clickCallBack($event)"></i>
          </ng-template>
        </p-datepicker>

        <ng-container *ngIf="selectionMode === 'range' && _value[1]">
          <span class="time-picker__date">
            {{ _value[1] | date : "dd MMM" : "" : langauge }}
          </span>
          <p-datepicker
            [(ngModel)]="timePickerTo"
            [inline]="true"
            [iconDisplay]="'input'"
            [showIcon]="true"
            [timeOnly]="true"
            inputId="timerPickerTo"
          >
            <ng-template #inputicon let-clickCallBack="clickCallBack">
              <i class="pi pi-clock" (click)="clickCallBack($event)"></i>
            </ng-template>
          </p-datepicker>
        </ng-container>
      </div>

      <button pButton style="width: 90px" (click)="applyTime(op)">
        <span pButtonLabel>
          {{ "Zastosuj" | translate }}
        </span>
      </button>
    </div>

    <div
      *ngIf="maxSelectableDays"
      class="datepicker-popover__max-options-selected"
    >
      <span class="datepicker-popover__max-options-selected__title">
        <i class="pi pi-info-circle icon"></i>
        {{ "theMaximumDataRangeIs" | translate }} {{ maxSelectableDays }}
        {{
          maxSelectableDays === 1
            ? ("date-time.day" | translate)
            : ("date-time.days" | translate)
        }}
      </span>
    </div>

    <p-button
      (onClick)="resetValue(op)"
      [label]="'labels.clear' | translate"
      variant="text"
      severity="danger"
      class="clear-btn"
    />
  </div>
</p-popover>
